import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IconType } from 'shared/icons/SvgIcon';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface MenuItemProps {
  label: string;
  href: string;
  icon?: IconType;
  active?: boolean;
  onClick?: () => void;
  className?: string;
  count?: number;
}

export const MenuItem: FC<MenuItemProps> = ({
  label,
  href,
  icon: Icon,
  active,
  onClick,
  className = '',
  count,
}) => {
  return (
    <li
      className={mergeClasses(
        'rounded-lg transition-all',
        active ? 'bg-white/10 shadow-sm-primary lg:bg-white' : '',
        className,
      )}
    >
      <Link
        onClick={onClick}
        to={href}
        className="flex items-center justify-between gap-2 border-y border-transparent px-3 py-[7px] font-medium transition-all"
      >
        <div
          className={mergeClasses(
            'flex items-center gap-2',
            active
              ? 'text-white lg:text-black [&>div]:bg-primary [&>div]:text-white'
              : 'text-gray-400 lg:text-gray',
          )}
        >
          {Icon && (
            <div className="flex-center h-6.5 w-6.5 rounded-full transition-all">
              <Icon className="h-4 w-4" />
            </div>
          )}
          <span>{label}</span>
        </div>
        {!!count && (
          <span className="flex-center min-w-[27px] rounded-xl border border-primary bg-primary px-2.5 py-0.5 text-xs font-medium text-white">
            {count}
          </span>
        )}
      </Link>
    </li>
  );
};
